import { Resource } from '@features/resources/types';
import { Card } from '@features/ui/components';
import { envConfig } from '@root/envConfig';
import { TFunction, useTranslation } from 'next-i18next';
import { ResourcesSection } from './ResourcesSection';

const resources1: (t: TFunction) => Resource[] = t => [
  {
    title: t('pages.resources.links.aromatogramme'),
    type: 'pdf',
    url: envConfig.pdfUrls.aromatogramme,
  },
  {
    title: t('pages.resources.links.drugsRequest'),
    type: 'pdf',
    url: envConfig.pdfUrls.demandeMedicaments,
  },
];

const resources2: (t: TFunction) => Resource[] = t => [
  {
    title: t('pages.resources.links.consent'),
    type: 'pdf',
    url: envConfig.pdfUrls.consentementAnalyse,
  },
  {
    title: t('pages.resources.links.cryptoInstall'),
    type: 'link',
    url: envConfig.urls.cryptoInstall,
  },
];

const resources3: (t: TFunction) => Resource[] = t => [
  { title: t('pages.resources.links.vademecum'), type: 'link', url: envConfig.urls.vademecum },
];

export const AllResources = (): JSX.Element => {
  const { t } = useTranslation('common');

  return (
    <Card className="pt-9">
      <ResourcesSection title={t('pages.resources.orderForms')} resources={resources1(t)} />
      <ResourcesSection title={t('pages.resources.procedures')} resources={resources2(t)} />
      <ResourcesSection title={t('pages.resources.usefulResources')} resources={resources3(t)} />
    </Card>
  );
};
